// https://github.com/colinhacks/zod/blob/62b7842c46dd7f1004f41e2220284abb75378fb7/src/locales/en.ts

import {
  ZodErrorMap,
  ZodIssueCode,
  ZodParsedType,
  util,
} from 'zod';

const errorMap: ZodErrorMap = (issue, _ctx) => {
  let message: string;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = 'Erforderlich';
      } else {
        message = `Erwartet ${issue.expected}, erhalten ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Ungültiger Literalwert, erwartet ${JSON.stringify(
        issue.expected,
        util.jsonStringifyReplacer,
      )}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Nicht erkannte Schlüssel im Objekt: ${util.joinValues(
        issue.keys,
        ', ',
      )}`;
      break;
    case ZodIssueCode.invalid_union:
      message = 'Ungültige Eingabe';
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Ungültiger Diskriminatorwert. Erwartet ${util.joinValues(
        issue.options,
      )}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Ungültiger Enum-Wert. Erwartet ${util.joinValues(
        issue.options,
      )}, erhalten '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = 'Ungültige Funktionsargumente';
      break;
    case ZodIssueCode.invalid_return_type:
      message = 'Ungültiger Funktionsrückgabewert';
      break;
    case ZodIssueCode.invalid_date:
      message = 'Ungültiges Datum';
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === 'object') {
        if ('includes' in issue.validation) {
          message = `Ungültige Eingabe: muss "${issue.validation.includes}" enthalten`;

          if (typeof issue.validation.position === 'number') {
            message = `${message} an einer oder mehreren Positionen größer oder gleich ${issue.validation.position}`;
          }
        } else if ('startsWith' in issue.validation) {
          message = `Ungültige Eingabe: muss mit "${issue.validation.startsWith}" beginnen`;
        } else if ('endsWith' in issue.validation) {
          message = `Ungültige Eingabe: muss mit "${issue.validation.endsWith}" enden`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== 'regex') {
        message = `Ungültig ${issue.validation}`;
      } else {
        message = 'Ungültig';
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === 'array') {
        message = `Array muss ${

          issue.exact ? 'genau' : issue.inclusive ? 'mindestens' : 'mehr als'
        } ${issue.minimum} Element(e) enthalten`;
      } else if (issue.type === 'string') {
        if (issue.inclusive && issue.minimum === 1) {
          message = 'Darf nicht leer sein';
        } else {
          message = `String muss ${

            issue.exact ? 'genau' : issue.inclusive ? 'mindestens' : 'über'
          } ${issue.minimum} Zeichen enthalten`;
        }
      } else if (issue.type === 'number') {
        message = `Zahl muss ${

          issue.exact
            ? 'genau gleich '
            : issue.inclusive
              ? 'größer oder gleich '
              : 'größer als '
        }${issue.minimum} sein`;
      } else if (issue.type === 'date') {
        message = `Datum muss ${

          issue.exact
            ? 'genau '
            : issue.inclusive
              ? 'größer oder gleich '
              : 'größer als '
        }${new Date(Number(issue.minimum))} sein`;
      } else {
        message = 'Ungültige Eingabe';
      }
      break;
    case ZodIssueCode.too_big:
      if (issue.type === 'array') {
        message = `Array muss ${

          issue.exact ? 'genau' : issue.inclusive ? 'höchstens' : 'weniger als'
        } ${issue.maximum} Element(e) enthalten`;
      } else if (issue.type === 'string') {
        message = `String muss ${

          issue.exact ? 'genau' : issue.inclusive ? 'höchstens' : 'unter'
        } ${issue.maximum} Zeichen enthalten`;
      } else if (issue.type === 'number') {
        message = `Zahl muss ${

          issue.exact
            ? 'genau'
            : issue.inclusive
              ? 'weniger oder gleich'
              : 'weniger als'
        } ${issue.maximum} sein`;
      } else if (issue.type === 'bigint') {
        message = `BigInt muss ${

          issue.exact
            ? 'genau'
            : issue.inclusive
              ? 'weniger oder gleich'
              : 'weniger als'
        } ${issue.maximum} sein`;
      } else if (issue.type === 'date') {
        message = `Datum muss ${

          issue.exact
            ? 'genau'
            : issue.inclusive
              ? 'kleiner oder gleich'
              : 'kleiner als'
        } ${new Date(Number(issue.maximum))} sein`;
      } else {
        message = 'Ungültige Eingabe';
      }
      break;
    case ZodIssueCode.custom:
      message = 'Ungültige Eingabe';
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = 'Schnittmenge der Ergebnisse konnte nicht zusammengeführt werden';
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Zahl muss ein Vielfaches von ${issue.multipleOf} sein`;
      break;
    case ZodIssueCode.not_finite:
      message = 'Zahl muss endlich sein';
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return {
    message,
  };
};

export default errorMap;
